import { TestCycle } from '@qality/common-model';

import {
  TestCycleSelectGroupedOptions,
  TestCycleSelectOption,
} from './TestCycleSelect.types';

export const mapTestCycleToTestCycleOption = (
  testCycle: TestCycle
): TestCycleSelectOption => {
  return {
    label: testCycle.name,
    value: testCycle.id,
    testCycle,
  };
};

export const mapTestCyclesToTestCycleOptions = (
  testCycles: Array<TestCycle>
): Array<TestCycleSelectOption> => {
  return testCycles.map(mapTestCycleToTestCycleOption);
};

export const mapTestCyclesToSelectGroupedOptions = (
  testCycles: Array<TestCycle>
): TestCycleSelectGroupedOptions => {
  return [
    {
      label: 'Test Cycles',
      options: mapTestCyclesToTestCycleOptions(testCycles),
    },
  ];
};

export const extendSelectOptions = (
  oldGroupedOptions: TestCycleSelectGroupedOptions,
  newGroupedOptions: TestCycleSelectGroupedOptions
): TestCycleSelectGroupedOptions => {
  return [
    {
      label: 'Test Cycles',
      options: [
        ...oldGroupedOptions[0].options,
        ...newGroupedOptions[0].options,
      ],
    },
  ];
};
